module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-2-e2bf5c4dfbab11dc20857edf3b47e82a.jpg";